import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    customModalName = "customModalName",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.customModalName]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    customModalName: state.components.contactUsForm.fieldValues["customModalName"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CustomModalStyles {
    modalSize?: ModalPresentationProps;
    ModalLink?: LinkPresentationProps;
}

export const customModalStyles: CustomModalStyles = {
    modalSize: {
        sizeVariant: "small",
    },
    ModalLink: {
        typographyProps: {
            size: 13,
        },
    },
};

const styles = customModalStyles;

const CustomModal: React.FC<Props> = ({ id, fields }) => {
    const { customModalName } = fields;
    const [isModalOpen, setIsModalOpen] = React.useState(false);

    const onModalClose = () => {
        setIsModalOpen(false);
    };

    return (
        <StyledWrapper>
            <Link {...styles.ModalLink} onClick={() => setIsModalOpen(true)}>
                {translate(customModalName)}
            </Link>
            <Modal
                headline={translate(customModalName)}
                {...styles.modalSize}
                isOpen={isModalOpen}
                handleClose={() => onModalClose()}
            >
                <Zone contentId={id} zoneName="hgf" />
            </Modal>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CustomModal),
    definition: {
        group: "Contact Us",
        fieldDefinitions: [
            {
                name: fields.customModalName,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Company Name",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
